// Text of the renewal banner an operator's admin sees in the last 7 days of a paid period.
// `sub` is the gateway's /subscription.json ({ state, daysLeft, paidUntil }); anything else shows nothing.
export const bannerText = (sub) => {
  if (sub?.state !== 'expiring') return '';
  const when = sub.daysLeft <= 1 ? 'today' : `in ${sub.daysLeft} days`;
  return `Your subscription ends ${when} (${sub.paidUntil}). Contact Orvyn to renew so your CRM keeps working.`;
};
